import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './SubmitForm.css';
import ConfirmDialog from '../../components/ConfirmDialog/ConfirmDialog';
import Notification from '../../components/Notification/Notification';
import privateAxios from '../../utils/axios/privateAxios';

const SubmitForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [formTitle, setFormTitle] = useState('');
    const [applicationReason, setApplicationReason] = useState('');
    const [loading, setLoading] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [notification, setNotification] = useState({ type: '', message: '' });

    const showNotification = (type, message) => {
        setNotification({ type, message });
        setTimeout(() => {
            setNotification({ type: '', message: '' });
        }, 5000);
    };

    const userId = localStorage.getItem('userId');

    useEffect(() => {
        const fetchFormTitle = async () => {
            try {
                const res = await privateAxios.get(`/private/form-title/${id}`);
                setFormTitle(res.data.form.title || 'Application Form');
            } catch (err) {
                showNotification('error', 'Failed to load form details.');
            }
        };
        fetchFormTitle();
    }, [id]);

    const handleSubmit = async () => {
        try {
            setLoading(true);
            // Send JSON instead of FormData
            const response = await privateAxios.post(`/private/submit-form/${id}`, {
                userId,
                applicationReason,
                formTitle
            });

            if (response.status === 201) {
                showNotification('success', 'Application submitted successfully!');
                setTimeout(() => {
                    navigate('/applications'); // Redirect after notification
                }, 3000);
            }
        } catch (error) {
            // Show error notification from server response or default
            showNotification('error', error.response?.data?.message || 'Submission failed.');
        } finally {
            setLoading(false);
            setShowConfirm(false);
        }
    };

    const onFormSubmit = (e) => {
        e.preventDefault();
        if (!applicationReason.trim()) {
            showNotification('error', 'Please provide a reason for your application.');
            return;
        }
        setShowConfirm(true);
    };

    return (
        <div className="submit-form">
            {showConfirm && (
                <ConfirmDialog
                    message="Are you sure you want to submit this application?"
                    onConfirm={handleSubmit}
                    onCancel={() => setShowConfirm(false)}
                    loading={loading}
                />
            )}

            <Notification
                type={notification.type}
                message={notification.message}
                onClose={() => setNotification({ type: '', message: '' })}
            />

            <form className="submit-form-container" onSubmit={onFormSubmit}>
                <h2>{formTitle}</h2>

                <div className="submit-form-group">
                    <label>Why are you applying? *</label>
                    <textarea
                        rows="5"
                        name="applicationReason"
                        value={applicationReason}
                        onChange={(e) => setApplicationReason(e.target.value)}
                        required
                    />
                </div>

                <button type="submit" className="submit-btn" disabled={loading}>
                    {loading ? 'Submitting...' : 'Submit Application'}
                </button>
            </form>
        </div>
    );
};

export default SubmitForm;